import { o_util } from "../../../common/namespaces.js";
import type { NexusHandler } from "../../nexus/function/function.types.js";
import type { OnexRaw } from "../index.js";
import { getAssignments } from "./getAssignments.js";

const onexSync = o_util.onex;

/**
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 */
export const isOnexVariantAsync = (async (onexId, variantId) =>
  onexSync.isOnexVariant.call(
    onexSync.customAssignments(await getAssignments()),
    onexId,
    variantId,
  )) satisfies NexusHandler<OnexRaw["isOnexVariant"]>;

/**
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 */
export const mapOnexVariantAsync = (async (onexId, variantMap, ...a) =>
  onexSync.mapOnexVariant.call(
    onexSync.customAssignments(await getAssignments()),
    onexId,
    variantMap,
    ...a,
  )) satisfies NexusHandler<OnexRaw["mapOnexVariant"]>;
